import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../../lib/metaPixel';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  /** If true, the button links out to the external checkout. If false (default), it smooth-scrolls to the offer section. */
  checkout?: boolean;
}
const CHECKOUT_URL = 'https://www.comerybajar.com/cart/53789889069424:1';
export function Button({
  children,
  className = '',
  fullWidth = false,
  checkout = false
}: ButtonProps) {
  const scrollToOffer = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const offerSection = document.getElementById('offer');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handleCheckoutClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Prevent default navigation so we can guarantee the pixel fires
    e.preventDefault();
    try {
      trackAddToCart();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[Meta Pixel] AddToCart error', err);
    }
    // Open the checkout in a new tab AFTER the event has been queued/sent.
    // A small timeout gives the beacon time to flush before some browsers
    // throttle background tabs.
    window.setTimeout(() => {
      window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
    }, 120);
  };
  const sharedClass = `
    inline-flex items-center justify-center
    bg-brand-gold hover:bg-brand-goldHover text-white 
    font-bold py-4 px-8 rounded-lg shadow-lg 
    transition-colors duration-300 text-center cursor-pointer
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  if (checkout) {
    return <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={sharedClass} data-event="add-to-cart" data-id="element-404">
        {children}
      </motion.a>;
  }
  return <motion.a href="#offer" onClick={scrollToOffer} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={sharedClass} data-id="element-405">
      {children}
    </motion.a>;
}